<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>回访客户列表</h4>
        </div>
        <div class="main-bd mg20">

            <el-row>
                <el-form ref="form" :inline="true" :key="$route.path" :model="searcherModel" class="demo-form-inline">
                    <el-form-item label="客户名称">
<!--                        <CustomerSelect ref="CustomerSelect" :customer-idss="searcherModel.customer_name" v-model="searcherModel.customer_name"-->
<!--                                        @change="CustomerHandleChange">-->
<!--                        </CustomerSelect>-->

                        <el-input size="small" v-model="searcherModel.customer_name" placeholder="请输入客户名称"></el-input>

                    </el-form-item>

                    <DistrictLinkage ref="DistrictLinkage"
                                     :provinceId="parseInt(searcherModel.province_id)"
                                     :cityId="parseInt(searcherModel.city_id)"
                                     :districtId="parseInt(searcherModel.district_id)"
                                     @change="handleChange($event)">
                    </DistrictLinkage>

                    <el-form-item label="业务员">
                        <UserSelect ref="user" :name="searcherModel.username" v-model="searcherModel.username" @change="UserHandleChange"></UserSelect>
                    </el-form-item>

                    <el-form-item v-show="activeTabName == 'allocated'" label="客服">
                        <UserSelect ref="customer_service" :name="searcherModel.service_name" v-model="searcherModel.service_name"
                                    @change="serviceChange"></UserSelect>
                    </el-form-item>

                    <el-form-item label="回访时间">
                        <el-date-picker
                                size="small"
                                type="daterange"
                                unlink-panels
                                v-model="searcherModel.visit_times"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>

                    <el-form-item label="录单时间">
                        <el-date-picker
                                size="small"
                                type="daterange"
                                unlink-panels
                                v-model="searcherModel.order_times"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>



                    <el-form-item label="订单类型">
                        <el-select size="small" v-model="searcherModel.order_type" placeholder="请选择">
                            <el-option v-for="(item, key) in orderTypes" :label="item.label"
                                       :value="item.value" :key="key">
                            </el-option>
                        </el-select>
                        <el-select size="small" v-model="searcherModel.product_id" placeholder="请选择" @click="getproduct()">
                          <el-option v-for="(item, key) in products" :key="key" :label="item.name" :value="item.id">
                          </el-option>
                        </el-select>
                    </el-form-item>


                    <el-form-item label="合同到期时间">
                        <el-date-picker
                                size="small"
                                type="daterange"
                                unlink-panels
                                v-model="searcherModel.contract_times"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>

                    <el-form-item label="合同上传时间">
                        <el-date-picker
                                size="small"
                                type="daterange"
                                unlink-panels
                                v-model="searcherModel.upload_times"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>

                    <el-form-item v-show="activeTabName=='allocated'" label="分配时间">
                        <el-date-picker
                                size="small"
                                type="daterange"
                                unlink-panels
                                v-model="searcherModel.allocation_times"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>

                    <br/>

                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="submitSearch">搜索
                        </el-button>
                        <el-button size="small" @click="resetForm">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-row>

            <el-row class="addBtn">
                <el-button :disabled="disableBatchOption"
                           v-if="Acs('/customers/assign') && activeTabName=='visits' || activeTabName=='allocated' "
                           type="primary" size="small"
                           @click="showServiceDialog = true">批量分配客服
                </el-button>
                <el-button :disabled="disableBatchOption" type="danger" size="small" @click="removeAssign"
                           v-if="Acs('/customers/remove-assign') && activeTabName == 'allocated' || activeTabName == 'my-visits'">
                    解除分配
                </el-button>
                <el-button v-show="Acs('/customer/visits/export')" size="small" @click="exportVisits" type="success">导出数据</el-button>
            </el-row>

            <el-tabs v-model="activeTabName">
                <el-tab-pane v-if="$route.path == '/customers/my-visits' && Acs('/customers/my-visits')" label="我的回访客户" name="my-visits"></el-tab-pane>
                <el-tab-pane v-if="$route.path == '/customers/visits' && Acs('/customers/visits')" label="待分配" name="visits"></el-tab-pane>
                <el-tab-pane v-if="$route.path == '/customers/visits' && Acs('/customers/visits')" label="已分配" name="allocated"></el-tab-pane>
            </el-tabs>

            <el-table :data="customers" style="width: 100%" class="tabTopBorder" v-loading="loading"
                      @selection-change="handleSelectionChange" :default-expand-all="false">

                <el-table-column prop="customer_id" type="selection"></el-table-column>
                <el-table-column prop="order_id" label="ID" width="100">
                    <template slot-scope="scope">
                        <el-tooltip placement="bottom-start">
                            <div slot="content">
                                <span>客户联系人：{{scope.row.contact_name}}</span><br>
                                <span>客户手机号：{{scope.row.contact_mobile}}</span>
                                <el-button v-if="scope.row.contact_mobile != ''" type="text" size="mini" icon="el-icon-unlock" @click="unlockMobile(scope.row)">解密</el-button>
                            </div>
                            <div>
                                {{scope.row.order_id}}
                            </div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="order_type" label="类型" width="100"></el-table-column>
                <el-table-column label="客户名称" prop="customer_name">
                    <template slot-scope="scope">
                        <el-link>
                            <router-link target="_blank"
                                         :to="{path: '/customers/view', query: {id: scope.row.customer_id}}">
                                {{scope.row.customer_name}}
                            </router-link>
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="district_names" label="所在地区" width="180"></el-table-column>
                <el-table-column prop="created_at" label="录单时间"></el-table-column>
                <el-table-column prop="contract_end_time" label="合同到期时间"></el-table-column>
                <el-table-column prop="upload_at" label="合同传附时间"></el-table-column>
              <el-table-column label="最后跟进时间" width="180">
                <template slot-scope="scope">
                  <el-tooltip v-if="scope.row.last_trace" class="item" effect="light"
                              :content="scope.row.last_trace.content" placement="top">
                    <el-link type="primary">{{scope.row.last_trace.created_at}}</el-link>
                  </el-tooltip>
                  <span v-else>暂无跟进</span>
                </template>
              </el-table-column>
                <el-table-column label="最后回访时间" width="180">
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.last_visit" class="item" effect="light"
                                    :content="scope.row.last_visit.content" placement="top">
                            <el-link type="primary">{{scope.row.last_visit.created_at}}</el-link>
                        </el-tooltip>
                        <span v-else>暂无回访</span>
                    </template>
                </el-table-column>
                <el-table-column prop="last_visit.type_label" label="回访类型"></el-table-column>
                <el-table-column prop="last_visit.method_label" label="回访方式"></el-table-column>
                <el-table-column prop="last_visit.status_label" label="回访状态"></el-table-column>
                <el-table-column prop="sales_name" label="业务员"></el-table-column>
                <el-table-column v-if="activeTabName == 'allocated' || activeTabName== 'my-visits'" prop="allocation_at" label="分配时间"></el-table-column>
                <el-table-column prop="service_name" label="客服人员"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="handleView(scope.row)" type="text" size="small">查看</el-button>
                        <el-button @click="writeVisit(scope.row)" type="text" size="small">添加记录</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage" :enableEvent="true" @change="watchPageChange"></pagination>
            </el-row>

            <!-- 回访组件 -->
            <visit-modal
                    :show-dialog="showVisitModal"
                    :customer-id="currentRow.customer_id"
                    @closeModal="closeModal"
            >
            </visit-modal>

            <el-dialog title="分配客户给客服" :visible.sync="showServiceDialog" width="20%">
                <el-form :model="form">
                    <el-form-item label="客服姓名">
                        <UserSelect1 v-if="showServiceDialog" v-model="form.user_id"
                                     @change="watchCustomerServiceSelect"></UserSelect1>
                    </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="showServiceDialog = false">取 消</el-button>
                    <el-button type="primary" @click="handleAssign()" :loading="loading">确 定</el-button>
                </div>
            </el-dialog>

        </div>
    </div>
</template>
<style>
.el-tooltip__popper {
  max-width: 400px;
  line-height: 180%;
}
</style>

<script>

    import CustomerService from "~/services/customer";
    import CommonService from "~/services/common";
    import Pagination from "~/widgets/Pagination.vue";
    import UserSelect1 from "~/widgets/UserSelectCorp.vue";
    import VisitModal from "~/views/tasks/VisitModal.vue";
    import CustomerSelect from "~/widgets/CustomerSelect.vue";
    import UserSelect from "~/widgets/UserSelect.vue";
    import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
    import Config from "~/config/params";
    import Function from "~/common/functions";
    import AccountService from "~/services/account";
    import ContactService from "~/services/contact";

    export default {
        name: "VisitCustomers",
        components: {
            Pagination,
            UserSelect1,
            VisitModal,
            CustomerSelect,
            UserSelect,
            DistrictLinkage
        },
        data() {
            return {
                // 默认激活的tab
                activeTabName: '',
                customers: [],
                loading: false,
                linkPage: null,
                disableBatchOption: true,
                selection: [],
                showServiceDialog: false,
                //客户绑定，删除
                form: {
                    customer_ids: [],
                    user_id: '',
                },
                currentRow: {},
                showVisitModal: false,
                searcherModel: {
                    order_type: '',
                    product_id:'',
                    username: '',
                    service_name: '',
                    customer_name: '',
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                    visit_times: [],
                    order_times: [],
                    contract_times: [],
                    allocation_times: [],
                    upload_times: []
                },
                product_types:Config.getType(),
                products:[],
                orderTypes: [{
                    value: null,
                    label: '全部'
                },{
                    value: Config.TYPE_FORMAL,
                    label: '正式(新单)'
                }, {
                    value: Config.TYPE_RENEW,
                    label: '正式(续单)'
                },
                ],

            };
        },
        created() {
            this.setTabByPath(this.$route.path);
            if (this.customers.length == 0) {
                this.getListByTab();
            }
            //加载产品列表
            CommonService.getProducts({
              is_deleted: 0,
              fields: 'id,name,price,code'
            }).then(res => {
              this.products = res.data
            });

        },
        watch: {
            selection: function (value, oldValue) {
                if (value.length > 0) {
                    this.disableBatchOption = false;
                } else {
                    this.disableBatchOption = true;
                }
            },

            '$route.path': function (value, oldValue) {
                this.resetFields();
                this.setTabByPath(value);
            },

            activeTabName: function (value, oldValue) {
                // 第一次加载不触发加载，不然会加载两次
                if (oldValue != '') {
                    this.resetFields();
                    this.getListByTab();
                }
            }
        },
        destroyed(){
            delete localStorage['/customers/my-visits'+this.$store.getters.token];
            delete localStorage['/customers/visits'+this.$store.getters.token];
        },
        methods: {
            submitSearch() {
                // loading 动画
                this.loading = true;
                localStorage.setItem(this.$route.path+this.$store.getters.token,JSON.stringify(this.searcherModel));
                this.getListByTab(this.searcherModel);
            },

            resetFields() {
                this.searcherModel = Object.assign({}, this.searcherModel, {
                    order_type: '',
                    product_id:'',
                    username: '',
                    service_name: '',
                    customer_name: '',
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                    visit_times: [],
                    order_times: [],
                    contract_times: [],
                    allocation_times: [],
                    upload_times: []
                });
                delete localStorage[this.$route.path+this.$store.getters.token];
            },

            // 重置筛选表单
            resetForm() {
                this.$refs["form"].resetFields();
                this.$refs["DistrictLinkage"].reset();
                this.$refs['user'].reset();
                this.resetFields();
                this.getListByTab()
            },

            //客户名称远程搜索组件赋值
            CustomerHandleChange(object) {
                this.searcherModel.customer_name = object.value;
            },

            setTabByPath(path) {
                switch (path) {
                    case '/customers/visits':
                        this.activeTabName = 'visits';
                        break;
                    case '/customers/my-visits':
                        this.activeTabName = 'my-visits';
                        break;
                }
            },

            getListByTab(params) {
                if (!params) {
                    params = {};
                }
                switch (this.activeTabName) {
                    case 'my-visits':
                        //params['mode'] = 3 // 查看自己的
                        this.getMyVisits(params);
                        break;
                    case 'visits':
                        params['mode'] = 2; // 待分配
                        this.getAllVisits(params);
                        break;
                    case 'allocated':
                        params['mode'] = 1; // 已分配
                        this.getAllVisits(params);
                        break;
                    default:
                        this.$message.error("无效的 tab 项");
                        break;
                }

            },

            // 全部回访客户列表
            getAllVisits(params = {}) {
                this.loading = true;
                CustomerService.getVisitCustomers(params).then(res => {
                    if (res.code == 0) {
                        this.customers = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                    }
                    this.loading = false;
                })
            },

            // 我的回访客户列表
            getMyVisits(params = {}) {
                this.loading = true;
                CustomerService.getMyVisitCustomers(params).then(res => {
                    if (res.code == 0) {
                        this.customers = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                    }
                    this.loading = false;
                })
            },

            //全选，全不选
            handleSelectionChange(customers) {
                this.selection = [];
                customers.forEach(row => {
                    this.selection.push(row.customer_id);
                });
            },

            // 监听分页切换回调
            watchPageChange(pageParams) {
                let params = this.searcherModel;
                params['page'] = pageParams["page"];
                params['perPage'] = pageParams["perPage"];
                this.getListByTab(params);
            },

            handleView(customer) {
                let routeData = this.$router.resolve({
                    path: "/customers/view",
                    query: {id: customer.customer_id},
                });
                window.open(routeData.href, '_blank');
            },

            //业务员姓名远程搜索组件赋值
            UserHandleChange(value) {
                this.searcherModel.username = value.value;
            },

            serviceChange(value) {
                this.searcherModel.service_name = value.value
            },

            // 监听选择客服
            watchCustomerServiceSelect(value) {
                this.form.user_id = value
            },


            /**
             * 处理分配客服
             */
            handleAssign() {
                if (this.selection.length > 0) {
                    this.loading = true;
                    this.form.customer_ids = this.selection;
                    CustomerService.assign(this.form).then(res => {
                        if (res.code == 0) {

                            this.$message({
                                message: "分配成功!",
                                type: "success",
                                showClose: true,
                            });

                            this.getListByTab();

                            this.form = {
                                customer_ids: [],
                                user_id: '',
                            };
                            this.showServiceDialog = false;
                        }
                        this.loading = false;
                    }).catch(() => {
                        this.loading = false;
                    });
                } else {
                    this.$message.error("请先选择要分配的客户");
                    return;
                }


            },
            // 填写跟进记录
            writeVisit(row) {
                if (!row) {
                    return;
                }

                this.currentRow = row;
                this.showVisitModal = true;

            },

            // 监听对话框关闭事件
            closeModal(isShow) {
                this.showVisitModal = isShow;
                //this.isFinished = isShow;
                this.getListByTab();
            },

            removeAssign() {
                this.$confirm("确定要将客服与这些客户解除分配关系吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {

                    if (this.selection.length > 0) {
                        this.form.customer_ids = this.selection;
                        CustomerService.removeAssign(this.form).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    message: "解除分配成功!",
                                    type: "success",
                                    showClose: true,
                                });
                                this.getListByTab();
                                this.form = {
                                    customer_ids: [],
                                    user_id: '',
                                };
                            }
                        })
                    } else {
                        this.$message.error("请先选择要解除分配关系的客户");
                        return;
                    }

                }).catch(() => {
                });
            },

            //地区联动 Cascader 级联选择器,切换事件,表单model赋值
            handleChange(value) {
                this.searcherModel.province_id = value[0];
                this.searcherModel.city_id = value[1];
                this.searcherModel.district_id = value[2];
            },

            exportVisits() {

                let reqParams = this.searcherModel;
                switch (this.activeTabName) {
                    case 'my-visits':
                        reqParams['mode'] = 3;// 查看自己的
                        break;
                    case 'visits':
                        reqParams['mode'] = 2; // 待分配
                        break;
                    case 'allocated':
                        reqParams['mode'] = 1; // 已分配
                        break;
                    default:
                        this.$message.error("无效的导出类型");
                        break;
                }

                let elemIF = document.createElement("iframe");
                let url = '/api/customer/visits/export?';
                let params = [];
                reqParams['access-token'] = AccountService.getAccessTokenByCache();
                Object.keys(reqParams).forEach((key) => {
                    let value = reqParams[key];
                    if (value == null) {
                        return;
                    }
                    switch (key) {
                        case 'visit_times':
                        case 'order_times':
                        case 'contract_times':
                        case 'allocation_times':
                        case 'upload_times':
                                key = key + '[]';
                                if (value[0] && value[1]) {
                                    let start_time = value[0];
                                    let end_time = value[1];
                                    params.push([key, encodeURIComponent(start_time)].join('='));
                                    params.push([key, encodeURIComponent(end_time)].join('='));
                                }
                            break;
                        default:

                            params.push([key, encodeURIComponent(value)].join('='))
                            break;
                    }
                })

                let str = params.join('&');
                elemIF.width = 0;
                elemIF.height = 0;
                elemIF.src = url+str;
                elemIF.style.display = "none";
                document.body.appendChild(elemIF);
            },

            unlockMobile(row) {
                ContactService.decodeMobile({id: row.order_id, type: 4}).then(res => {
                    if (res.code == 0 && res.data) {
                        this.$message.success("解密成功！");
                        if(res.data.mobile > 0){
                            row.contact_mobile = res.data.mobile;
                        }else if(res.data.phone_number > 0){
                            row.contact_mobile = res.data.phone_number;
                        }
                    }
                })
            },

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/customer/VisitCustomers.vue